export const cn = [
  {
    _id: 'a-little-queens-huge-crown',
    name: '\u5c0f\u5c0f\u5973\u738b\u7684\u5de8\u5927\u738b\u51a0',
    rarity: 5,
    role: 'warrior',
  },
  { _id: 'abyssal-crown', name: '\u6df1\u6e0a\u738b\u51a0', rarity: 5, role: 'mage' },
  {
    _id: 'airtosurface-missile-misha',
    name: '\u7a7a\u5bf9\u5730\u5bfc\u5f39\uff1a\u7f8e\u838e',
    rarity: 5,
    role: 'ranger',
  },
  { _id: 'alabastron', name: '\u96ea\u82b1\u77f3\u818f\u74f6', rarity: 5, role: 'assassin' },
  {
    _id: 'alencinoxs-wrath',
    name: '\u827e\u83b2\u897f\u8bfa\u514b\u65af\u7684\u9006\u9cde',
    rarity: 5,
    role: 'warrior',
  },
  { _id: 'alexas-basket', name: '\u96c5\u8389\u838e\u7684\u63d0\u7bee', rarity: 5, role: 'assassin' },
  { _id: 'ancient-dragons-legacy', name: '\u53e4\u9f99\u9057\u4ea7', rarity: 5, role: 'knight' },
  { _id: 'bastion-of-perlutia', name: '\u6ce2\u9c81\u8fea\u4e9a\u7684\u5821\u5792', rarity: 5, role: 'knight' },
  { _id: 'black-hand-of-the-goddess', name: '\u5973\u795e\u7684\u9ed1\u624b', rarity: 5, role: 'mage' },
  { _id: 'bloodseared-moon', name: '\u8840\u67d3\u4e4b\u6708', rarity: 5, role: '' },
  { _id: 'bloodstone', name: '\u8840\u7389\u9ad3', rarity: 5, role: 'ranger' },
  { _id: 'bloody-rose', name: '\u8840\u73ab\u7470', rarity: 5, role: 'mage' },
  { _id: 'border-coin', name: '\u5b64\u6ce8\u4e00\u63b7', rarity: 5, role: 'warrior' },
  { _id: 'celestine', name: '\u5929\u9752\u77f3', rarity: 5, role: 'manauser' },
  { _id: 'champions-trophy', name: '\u4f18\u80dc\u8005\u5956\u676f', rarity: 5, role: 'warrior' },
  { _id: 'chatty', name: '\u67f4\u8fea', rarity: 5, role: 'mage' },
  { _id: 'circus-fantasia', name: '\u5947\u5e7b\u9a6c\u620f\u56e2', rarity: 5, role: 'warrior' },
  { _id: 'cradle-of-life', name: '\u751f\u547d\u6447\u7bee', rarity: 5, role: 'warrior' },
  {
    _id: 'creation-destruction',
    name: '\u521b\u9020\u4e4b\u798f\uff06\u7834\u574f\u4e4b\u9882',
    rarity: 5,
    role: 'warrior',
  },
  { _id: 'crimson-moon-of-nightmares', name: '\u7ea2\u8272\u5669\u68a6\u4e4b\u6708', rarity: 5, role: 'mage' },
  { _id: 'crown-of-glory', name: '\u8363\u8000\u4e4b\u51a0', rarity: 5, role: 'knight' },
  { _id: 'cruel-mischief', name: '\u6b8b\u9177\u7684\u73a9\u7b11', rarity: 5, role: '' },
  { _id: 'dignus-orb', name: '\u5c0a\u4e25\u5b9d\u73e0', rarity: 5, role: 'mage' },
  { _id: 'doctors-bag', name: '\u6025\u6551\u5305', rarity: 5, role: 'manauser' },
  { _id: 'doubleedged-decrescent', name: '\u53cc\u5203\u4e0b\u5f26\u6708', rarity: 5, role: 'assassin' },
  { _id: 'draco-plate', name: '\u9f99\u65cf\u677f\u7532', rarity: 5, role: 'warrior' },
  { _id: 'durandal', name: '\u675c\u5170\u6708', rarity: 5, role: 'warrior' },
  { _id: 'dux-noctis', name: '\u6697\u591c\u6307\u6325\u8005', rarity: 5, role: 'ranger' },
  { _id: 'elbris-ritual-sword', name: '\u57c3\u5e03\u5229\u65af\u7684\u5b9d\u5251', rarity: 5, role: 'knight' },
  { _id: 'eticas-scepter', name: '\u827e\u5e1d\u5609\u6743\u6756', rarity: 5, role: 'mage' },
  { _id: 'fairy-tale-for-a-nightmare', name: '\u5669\u68a6\u7ae5\u8bdd', rarity: 5, role: 'mage' },
  { _id: 'guiding-light', name: '\u5f15\u5bfc\u4e4b\u5149', rarity: 5, role: 'ranger' },
  { _id: 'holy-sacrifice', name: '\u795e\u5723\u727a\u7272', rarity: 5, role: 'knight' },
  { _id: 'idols-cheer', name: '\u6b4c\u59ec\u52a9\u9635', rarity: 5, role: 'manauser' },
  { _id: 'iron-fan', name: '\u94c1\u6247', rarity: 5, role: 'ranger' },
  { _id: 'junkyard-dog', name: 'Junkyard Dog', rarity: 5, role: 'warrior' },
  { _id: 'justice-for-all', name: '\u4e3a\u4f17\u4eba\u7684\u6b63\u4e49', rarity: 5, role: 'knight' },
  { _id: 'knowledge-seed', name: '\u77e5\u8bc6\u79cd\u5b50', rarity: 5, role: 'mage' },
  { _id: 'last-teatime', name: '\u6700\u540e\u7684\u4e0b\u5348\u8336', rarity: 5, role: 'mage' },
  { _id: 'manica-of-control', name: '\u63a7\u5236\u7684\u62a4\u81c2', rarity: 5, role: 'assassin' },
  { _id: 'manifu', name: '\u739b\u5c3c\u666e', rarity: 5, role: '' },
  { _id: 'merciless-glutton', name: '\u65e0\u60c5\u7684\u5927\u98df\u5ba2', rarity: 5, role: 'warrior' },
  { _id: 'ms-confille', name: 'Miss Confile', rarity: 5, role: 'ranger' },
  { _id: 'necro-undine', name: '\u6076\u9b54\uff06\u5929\u4f7f', rarity: 5, role: 'mage' },
  { _id: 'noble-oath', name: '\u9ad8\u6d01\u7684\u8a93\u8a00', rarity: 5, role: 'knight' },
  { _id: 'otherworldly-machinery', name: '\u5f02\u754c\u7684\u673a\u68b0', rarity: 5, role: 'ranger' },
  { _id: 'proof-of-valor', name: '\u52c7\u731b\u8bc1\u636e', rarity: 5, role: '' },
  {
    _id: 'reingars-special-drink',
    name: '\u96f7\u8335\u683c\u5c14\u7279\u8c03\u996e\u6599',
    rarity: 5,
    role: 'ranger',
  },
  { _id: 'rhianna-luciella', name: '\u91cc\u5b89\u5a1c\uff06\u8def\u897f\u827e\u62c9', rarity: 5, role: 'assassin' },
  { _id: 'rise-of-a-monarch', name: '\u738b\u7684\u8bde\u751f', rarity: 5, role: 'knight' },
  { _id: 'rod-of-amaryllis', name: '\u5b64\u633a\u82b1\u4e4b\u6756', rarity: 5, role: 'manauser' },
  { _id: 'samsara-prayer-beads', name: '\u5faa\u73af\u5ff5\u73e0', rarity: 5, role: 'warrior' },
  { _id: 'secret-art-storm-sword', name: '\u79d8\u7b08\uff1a\u96f7\u5929\u4e00\u5251', rarity: 5, role: 'assassin' },
  { _id: 'shepherd-of-the-hollow', name: '\u65e0\u4e3a\u7684\u5f15\u5bfc\u8005', rarity: 5, role: 'assassin' },
  { _id: 'shimadra-staff', name: '\u5e2d\u739b\u5fb7\u62c9\u7684\u624b\u6756', rarity: 5, role: 'manauser' },
  { _id: 'sigurd-scythe', name: '\u5e2d\u683c\u52d2\u8d5b\u65af', rarity: 5, role: 'warrior' },
  { _id: 'snow-crystal', name: '\u767d\u96ea\u6c34\u6676', rarity: 5, role: 'warrior' },
  { _id: 'song-of-stars', name: '\u661f\u8fb0\u4e4b\u6b4c', rarity: 5, role: 'ranger' },
  { _id: 'spear-of-a-new-dawn', name: '\u5f00\u8f9f\u4e4b\u77db', rarity: 5, role: 'knight' },
  { _id: 'spirits-breath', name: '\u7cbe\u7075\u6c14\u606f', rarity: 5, role: 'mage' },
  { _id: 'star-piercer', name: '\u8fdb\u653b\u53f7\u89d2', rarity: 5, role: '' },
  { _id: 'stella-harpa', name: '\u661f\u4e4b\u7ad6\u7434', rarity: 5, role: 'manauser' },
  { _id: 'sword-of-ezera', name: '\u4f0a\u6770\u62c9\u7684\u5723\u5251', rarity: 5, role: 'knight' },
  { _id: 'sword-of-holy-light', name: '\u5723\u5149\u4e4b\u5251', rarity: 5, role: '' },
  { _id: 'sword-of-judgment', name: '\u5ba1\u5224\u4e4b\u5251', rarity: 5, role: 'ranger' },
  { _id: 'sword-of-summer-twilight', name: '\u590f\u591c\u95ea\u5200', rarity: 5, role: 'assassin' },
  { _id: 'time-matter', name: '\u65f6\u95f4\u7684\u7269\u8d28', rarity: 5, role: 'mage' },
  { _id: 'torn-sleeve', name: '\u6495\u88c2\u7684\u53f3\u8863\u8896', rarity: 5, role: 'assassin' },
  { _id: 'touch-of-rekos', name: '\u5217\u79d1\u65af\u7684\u6551\u63f4', rarity: 5, role: 'manauser' },
  { _id: 'twilight-calamity', name: '\u843d\u65e5\u4e4b\u707e', rarity: 5, role: 'mage' },
  { _id: 'uberiuss-tooth', name: '\u5c24\u8d1d\u91cc\u4e4c\u65af\u7684\u81fc\u9f7f', rarity: 5, role: 'warrior' },
  { _id: 'unfading-memories', name: '\u4e0d\u51cb\u96f6\u7684\u56de\u5fc6', rarity: 5, role: 'manauser' },
  { _id: 'unseen-observer', name: '\u9690\u5f62\u7684\u89c2\u5bdf\u8005', rarity: 5, role: 'ranger' },
  { _id: 'violet-talisman', name: '\u7d2b\u8272\u62a4\u8eab\u7b26', rarity: 5, role: 'assassin' },
  { _id: 'wall-of-order', name: '\u79e9\u5e8f\u62a4\u5899', rarity: 5, role: 'ranger' },
  { _id: 'war-horn', name: '\u8fdb\u653b\u53f7\u89d2', rarity: 5, role: '' },
  { _id: 'wind-rider', name: '\u4e58\u98ce\u8005', rarity: 5, role: 'assassin' },
  { _id: 'adamant-shield', name: '\u91d1\u521a\u77f3\u76fe\u724c', rarity: 4, role: 'knight' },
  { _id: 'ambrote', name: '\u5b89\u5e03\u7f57\u6cf0', rarity: 4, role: 'ranger' },
  { _id: 'andres-crossbow', name: '\u5b89\u5fb7\u70c8\u65af\u4e4b\u5f29', rarity: 4, role: 'ranger' },
  { _id: 'aurius', name: '\u4e9a\u4e4c\u5229\u65af', rarity: 4, role: 'knight' },
  { _id: 'barthezs-orbuculum', name: '\u5df4\u6cf0\u65af\u7684\u6c34\u6676\u7403', rarity: 4, role: 'mage' },
  { _id: 'bloody-warhammer', name: '\u8840\u8165\u6218\u9524', rarity: 4, role: '' },
  { _id: 'card-of-small-miracles', name: '\u5c0f\u5c0f\u5947\u8ff9\u8d3a\u5e74\u5361', rarity: 4, role: '' },
  { _id: 'celestial-spear', name: '\u5929\u7a7a\u4e4b\u77db', rarity: 4, role: '' },
  { _id: 'crimson-seed', name: '\u7ea2\u7130\u79cd\u5b50', rarity: 4, role: 'warrior' },
  { _id: 'dust-devil', name: '\u5c18\u57c3\u6076\u9b54', rarity: 4, role: 'assassin' },
  { _id: 'els-fist', name: '\u827e\u5c14\u4e4b\u62f3', rarity: 4, role: 'warrior' },
  { _id: 'elyhas-knife', name: '\u57c3\u91cc\u54c8\u5200', rarity: 4, role: 'assassin' },
  { _id: 'eternus', name: '\u57c3\u7279\u8bfa\u65af', rarity: 4, role: 'manauser' },
  { _id: 'flower-shower', name: '\u6d12\u82b1', rarity: 4, role: 'warrior' },
  { _id: 'golden-cocoa-cookie', name: '\u9ec4\u91d1\u53ef\u53ef\u8c46\u997c\u5e72', rarity: 4, role: '' },
  { _id: 'hell-cutter', name: '\u5730\u72f1\u5207\u5272\u673a', rarity: 4, role: 'warrior' },
  { _id: 'hilag-lance', name: '\u9521\u62c9\u9769\u9a91\u58eb\u957f\u77db', rarity: 4, role: 'knight' },
  { _id: 'iela-violin', name: '\u4f9d\u57c3\u841d\u5c0f\u63d0\u7434', rarity: 4, role: 'mage' },
  { _id: 'infinity-basket', name: '\u65e0\u9650\u63d0\u7bee', rarity: 4, role: 'ranger' },
  { _id: 'kaladra', name: '\u5609\u62c9\u7279\u62c9', rarity: 4, role: 'mage' },
  { _id: 'love-potion', name: '\u7231\u60c5\u7075\u4e39', rarity: 4, role: '' },
  {
    _id: 'magarahas-tome',
    name: '\u739b\u59ec\u62c9\u54c8\u7684\u9b54\u6cd5\u53e4\u4e66',
    rarity: 4,
    role: 'manauser',
  },
  { _id: 'midnight-bloom', name: '\u6708\u591c\u4e4b\u82b1', rarity: 4, role: '' },
  { _id: 'moonlight-dreamblade', name: '\u768e\u6708\u68a6\u591c', rarity: 4, role: 'assassin' },
  { _id: 'new-year-cookies', name: '\u8574\u542b\u5e78\u798f\u7684\u5c81\u672b\u997c\u5e72', rarity: 4, role: '' },
  { _id: 'one-year-of-gratitude', name: '\u5fc3\u5b58\u611f\u8c22\u7684\u4e00\u5e74', rarity: 4, role: '' },
  { _id: 'portrait-of-the-saviors', name: '\u6551\u63f4\u8005\u4eec\u7684\u753b\u50cf', rarity: 4, role: '' },
  { _id: 'radiant-forever', name: '\u707f\u70c2\u7684\u6c38\u6052', rarity: 4, role: 'mage' },
  { _id: 'rainbow-scale', name: '\u4eba\u9c7c\u516c\u4e3b\u7684\u9cde\u7247', rarity: 4, role: '' },
  { _id: 'rosa-hargana', name: '\u7f57\u6c99\u54c8\u52d2\u6208\u7eb3', rarity: 4, role: 'ranger' },
  { _id: 'santa-muerte', name: '\u6b7b\u4ea1\u5723\u795e', rarity: 4, role: 'assassin' },
  { _id: 'sashe-ithanes', name: '\u9999\u888b\u4f0a\u59b2\u6d85\u65af', rarity: 4, role: 'ranger' },
  { _id: 'sepulcrum', name: '\u585e\u5f17\u514b\u9c81\u59c6', rarity: 4, role: 'warrior' },
  { _id: 'shepherds-of-chaos', name: '\u6df7\u6c8c\u7684\u5f15\u5bfc\u8005\u4eec', rarity: 4, role: 'assassin' },
  { _id: 'silver-rain', name: '\u94f6\u5149\u9aa4\u96e8', rarity: 4, role: 'assassin' },
  { _id: 'siraren', name: '\u5e2d\u62c9\uff0d\u83b2', rarity: 4, role: 'mage' },
  { _id: 'spooky-solayu-stories', name: '\u5947\u95fb\u8f76\u4e8b\u5f55', rarity: 4, role: '' },
  { _id: 'steadfast-gatekeeper', name: '\u575a\u5b9a\u7684\u770b\u5b88\u8005', rarity: 4, role: 'knight' },
  { _id: 'strak-gauntlet', name: '\u53f2\u7279\u96f7\u514b\u62f3\u5957', rarity: 4, role: 'warrior' },
  { _id: 'succubus-mirror', name: '\u9b45\u9b54\u4e4b\u955c', rarity: 4, role: '' },
  { _id: 'tagehels-ancient-book', name: '\u5854\u514b\u8d6b\u5c14\u53e4\u4e66', rarity: 4, role: 'mage' },
  { _id: 'tear-of-the-desert', name: '\u6c99\u6f20\u4e4b\u6cea', rarity: 4, role: 'mage' },
  { _id: 'to-a-new-world', name: '\u81f4\u5d2d\u65b0\u7684\u65f6\u4ee3', rarity: 4, role: '' },
  { _id: 'waters-origin', name: '\u6ce2\u6d9b\u7684\u7948\u613f', rarity: 4, role: 'manauser' },
  { _id: 'wondrous-potion-vial', name: '\u7075\u836f\u7684\u8bd5\u7ba1', rarity: 4, role: 'manauser' },
  { _id: 'xvi-the-tower', name: 'XVI. The Tower', rarity: 4, role: '' },
  { _id: 'alsacian-spear', name: '\u827e\u5c14\u8d5b\u65af\u4e4b\u77db', rarity: 3, role: '' },
  { _id: 'ancient-sheath', name: '\u53e4\u4ee3\u5251\u9798', rarity: 3, role: '' },
  { _id: 'aqua-rose', name: '\u6c34\u73ab\u7470', rarity: 3, role: '' },
  { _id: 'ascending-axe', name: '\u53c2\u5929\u65a7', rarity: 3, role: '' },
  { _id: 'atmas-portal', name: '\u4e9a\u7279\u739b\u7684\u4f20\u9001\u95e8', rarity: 3, role: '' },
  { _id: 'butterfly-mandolin', name: '\u8774\u8776\u7684\u66fc\u9640\u6797', rarity: 3, role: '' },
  { _id: 'cursed-compass', name: '\u8bc5\u5492\u7684\u7f57\u76d8', rarity: 3, role: '' },
  { _id: 'daydream-joker', name: '\u767d\u65e5\u68a6\u5c0f\u4e11', rarity: 3, role: '' },
  { _id: 'devils-brand', name: '\u6076\u9b54\u70d9\u5370', rarity: 3, role: '' },
  { _id: 'egg-of-delusion', name: '\u8ff7\u60d1\u4e4b\u86cb', rarity: 3, role: '' },
  { _id: 'envoys-pipe', name: '\u6b7b\u795e\u70df\u6597', rarity: 3, role: '' },
  { _id: 'exorcists-tonfa', name: '\u6597\u9b3c\u7684\u62d0\u68cd', rarity: 3, role: '' },
  { _id: 'forest-totem', name: '\u7eff\u6797\u56fe\u817e', rarity: 3, role: '' },
  { _id: 'goblins-lamp', name: '\u9b3c\u602a\u660e\u706f', rarity: 3, role: '' },
  { _id: 'grail-of-blood', name: '\u9c9c\u8840\u5723\u676f', rarity: 3, role: '' },
  { _id: 'labyrinth-cube', name: '\u8ff7\u5bab\u7684\u65b9\u5757', rarity: 3, role: '' },
  { _id: 'mighty-yaksha', name: '\u91d1\u521a\u591c\u53c9', rarity: 3, role: '' },
  { _id: 'oath-key', name: '\u8a93\u7ea6\u94a5\u5319', rarity: 3, role: '' },
  { _id: 'prophetic-candlestick', name: '\u9884\u89c6\u7684\u70db\u53f0', rarity: 3, role: '' },
  { _id: 'ranons-memorandum', name: '\u62c9\u519c\u7684\u5907\u5fd8\u5f55', rarity: 3, role: '' },
  { _id: 'ruby-essence', name: '\u7ea2\u7389\u7cbe\u9ad3', rarity: 3, role: '' },
  { _id: 'sword-of-the-morning', name: '\u9ece\u660e\u5251', rarity: 3, role: '' },
  { _id: 'timeless-anchor', name: '\u6c38\u52ab\u4e4b\u951a', rarity: 3, role: '' },
];
